import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import VerticalBarChart from "../../../ceo/analysis/competitive/charts/vertical-bar";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../../../typeform/TypeformContent";

class TeamReportsSection6Step2 extends PureComponent {
  numberWithCommas = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  get left_content() {
    const { metrics, financeRaised, returnedToInvestors } = this.props;

    return (
      <span>
        In this round, Head of Finance raised $
        {this.numberWithCommas(financeRaised)} in capital to finance the
        business and ${this.numberWithCommas(returnedToInvestors)} were returned
        to investors. As a result, your capital structure and cost of capital
        are now {metrics.debt}% debt / {metrics.equity}% equity and{" "}
        {metrics.wacc}%, respectively.
        <br />
        <br />
        To learn more about Capital Structure and Cost of Capital, please review
        the following content:
        <br />
        <TypeformLink
          title="Capital Structure"
          url={TypeformUrls.CAPITAL_STRUCTURE}
        />
        <TypeformLink
          title="Cost of Capital"
          url={TypeformUrls.COST_OF_CAPITAL}
          className="link-with-margin"
        />
      </span>
    );
  }

  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    return data[team_id][key] || 0;
  };

  get CostOfCapital() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      const team = teams[team_id];
      data.push({
        name: team,
        value: this.getDataValue(team_id, "Cost of Capital") * 100
      });
    });

    return data;
  }

  get right_content() {
    return (
      <div className="team-reports-valign-center">
        <VerticalBarChart suffix="%" data={this.CostOfCapital} />
        <div className="text-center" style={{ marginTop: "-20px" }}>
          Cost of Capital
          <HelpIconButtonWithTooltipAndTypeformModal
            iconSize="xs"
            {...TypeformContent.COST_OF_CAPITAL}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Financing Analysis"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection6Step2;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-6/step-2.js